(() => {
  'use strict';

  const locale = (document.documentElement.lang || 'pt').toLowerCase().slice(0, 2);
  const languageRootRaw = document.documentElement.dataset.cnLanguageRoot || '/';
  const languageRoot = languageRootRaw === '/' ? '/' : languageRootRaw.replace(/\/$/, '');

  const labels = new Map([
    ['Início', 'Início'],
    ['Outlet', 'Outlet'],
    ['Body Cream Isabelle La Belle', 'Body Cream'],
    ['Perfumes Árabes', 'Perfumes'],
    ['Perfumes Nicho', 'Nicho'],
    ['Revenda', 'Revenda'],
    ['FAQ & Apoio', 'Apoio'],
    ['Envios & Devoluções', 'Envios & Devoluções'],
    ['Guias & Dicas', 'Guias'],
    ['Sobre Nós', 'Sobre Nós']
  ]);

  const clean = (value) => {
    const noEmoji = String(value || '')
      .replace(/[\p{Extended_Pictographic}\uFE0F\u200D]/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return labels.get(noEmoji) || noEmoji;
  };

  const polishNavigation = (root = document) => {
    root.querySelectorAll(
      '.header__inline-menu a, .header__inline-menu summary > span, menu-drawer a, menu-drawer summary span, .menu-drawer a, .menu-drawer summary span'
    ).forEach((el) => {
      el.childNodes.forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE) return;
        const next = clean(node.nodeValue);
        if (next) node.nodeValue = next;
      });
    });
  };

  const isLanguagePrefix = (path) => /^\/(en|es)(?:\/|$)/i.test(path);

  const stripLanguagePrefix = (path) => {
    const next = path.replace(/^\/(en|es)(?=\/|$)/i, '');
    return next || '/';
  };

  const localizedPath = (path) => {
    const cleanPath = stripLanguagePrefix(path || '/');
    if (languageRoot === '/') return cleanPath;
    if (cleanPath === '/') return languageRoot + '/';
    return languageRoot + (cleanPath.startsWith('/') ? cleanPath : '/' + cleanPath);
  };

  const preservePreviewParams = (targetUrl) => {
    const current = new URL(window.location.href);
    ['preview_theme_id', 'preview_key'].forEach((key) => {
      if (current.searchParams.has(key) && !targetUrl.searchParams.has(key)) {
        targetUrl.searchParams.set(key, current.searchParams.get(key));
      }
    });
  };

  const localizeInternalLinks = (root = document) => {
    if (!['en', 'es', 'pt'].includes(locale)) return;

    root.querySelectorAll('a[href]').forEach((a) => {
      const raw = a.getAttribute('href');
      if (
        !raw ||
        raw.startsWith('#') ||
        raw.startsWith('mailto:') ||
        raw.startsWith('tel:') ||
        raw.startsWith('javascript:') ||
        a.hasAttribute('hreflang') ||
        a.dataset.languageRoot
      ) return;

      let url;
      try {
        url = new URL(raw, window.location.origin);
      } catch (_) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      if (/^\/localization(?:\/|$)/.test(url.pathname)) return;

      const nextPath = localizedPath(url.pathname);
      if (nextPath !== url.pathname) url.pathname = nextPath;
      preservePreviewParams(url);

      const next = url.pathname + url.search + url.hash;
      if (a.getAttribute('href') !== next) a.setAttribute('href', next);
    });
  };

  const replaceText = (root, replacements) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      let value = node.nodeValue;
      if (!value || !value.trim()) return;
      replacements.forEach(([from, to]) => {
        value = value.replace(from, to);
      });
      if (value !== node.nodeValue) node.nodeValue = value;
    });
  };

  const localizeJudgeMe = (root = document) => {
    if (locale !== 'en' && locale !== 'es') return;

    const replacements = locale === 'en'
      ? [
          [/Avaliações de Clientes/gi, 'Customer Reviews'],
          [/Baseado em\s+(\d+)\s+avaliações/gi, 'Based on $1 reviews'],
          [/Baseado em\s+(\d+)\s+avaliação/gi, 'Based on $1 review'],
          [/Mais Recentes/gi, 'Most Recent'],
          [/Mais Antigos/gi, 'Oldest'],
          [/Mais Úteis/gi, 'Most Helpful'],
          [/Escrever uma avaliação/gi, 'Write a review'],
          [/Ver mais avaliações/gi, 'See more reviews'],
          [/Nenhuma avaliação/gi, 'No reviews yet'],
          [/avaliações/gi, 'reviews'],
          [/avaliação/gi, 'review'],
          [/(\d+(?:[.,]\d+)?)\s+de\s+5/gi, '$1 out of 5']
        ]
      : [
          [/Avaliações de Clientes/gi, 'Opiniones de clientes'],
          [/Baseado em\s+(\d+)\s+avaliações/gi, 'Basado en $1 reseñas'],
          [/Baseado em\s+(\d+)\s+avaliação/gi, 'Basado en $1 reseña'],
          [/Mais Recentes/gi, 'Más recientes'],
          [/Mais Antigos/gi, 'Más antiguas'],
          [/Mais Úteis/gi, 'Más útiles'],
          [/Escrever uma avaliação/gi, 'Escribir una reseña'],
          [/Ver mais avaliações/gi, 'Ver más reseñas'],
          [/Nenhuma avaliação/gi, 'Aún no hay reseñas'],
          [/avaliações/gi, 'reseñas'],
          [/avaliação/gi, 'reseña'],
          [/(\d+(?:[.,]\d+)?)\s+de\s+5/gi, '$1 de 5']
        ];

    const widgets = [];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches?.('.jdgm-widget, [class*="jdgm-rev-widg"]')) {
      widgets.push(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('.jdgm-widget, [class*="jdgm-rev-widg"]').forEach((widget) => widgets.push(widget));
    }

    if (widgets.length) {
      [...new Set(widgets)].forEach((widget) => replaceText(widget, replacements));
      return;
    }

    // Judge.me can inject/update its text asynchronously without replacing the widget root.
    // Restrict the fallback to the reviews section so product copy is never altered.
    const reviewRoots = root.querySelectorAll
      ? root.querySelectorAll('[data-judge-me], #judgeme_product_reviews, .jdgm-rev-widg, .jdgm-widget')
      : [];
    reviewRoots.forEach((widget) => replaceText(widget, replacements));
  };


  const polishShopifyForms = (root = document) => {
    const candidates = new Set();

    if (root?.nodeType === Node.ELEMENT_NODE && root.matches?.('shopify-forms-embed, [id^="app-embed-container-"]')) {
      candidates.add(root);
    }

    root?.querySelectorAll?.('shopify-forms-embed, [id^="app-embed-container-"]').forEach((node) => {
      candidates.add(node);
    });

    const polishHost = (host) => {
      const shadow = host?.shadowRoot;
      if (!shadow) return;

      const isFormsHost =
        host.tagName === 'SHOPIFY-FORMS-EMBED' ||
        shadow.querySelector('input[type="email"], form');

      if (!isFormsHost) return;

      if (!shadow.querySelector('style[data-cnobre-forms-mobile]')) {
        const style = document.createElement('style');
        style.setAttribute('data-cnobre-forms-mobile', 'true');
        style.textContent = '@media(max-width:749px){h1,h2,h3,[role="heading"]{padding-inline-end:58px!important;box-sizing:border-box!important}}';
        shadow.appendChild(style);
      }

      if (window.matchMedia('(max-width:749px)').matches) {
        const buttons = Array.from(shadow.querySelectorAll('button'));
        let closeButton = buttons.find((button) => {
          const label = [
            button.getAttribute('aria-label'),
            button.getAttribute('title'),
            button.textContent
          ].filter(Boolean).join(' ').trim().toLowerCase();

          return /close|fechar|cerrar|fermer|schließen|chiudi/.test(label) || label === '×' || label === 'x';
        });

        if (!closeButton) {
          closeButton = buttons.find((button) => {
            const rect = button.getBoundingClientRect();
            const style = window.getComputedStyle(button);
            return rect.width <= 64 &&
              rect.height <= 64 &&
              rect.top < 220 &&
              (style.position === 'absolute' || style.position === 'fixed');
          });
        }

        if (closeButton) {
          closeButton.style.setProperty('top', '12px', 'important');
          closeButton.style.setProperty('right', '12px', 'important');
          closeButton.style.setProperty('margin', '0', 'important');
          closeButton.style.setProperty('z-index', '30', 'important');
        }

        const titlePattern = /10\s*%.*(?:primeira\s+encomenda|first\s+order|primer\s+pedido)/i;
        const titleCandidates = Array.from(
          shadow.querySelectorAll('h1,h2,h3,[role="heading"],p,div,span')
        ).filter((node) => {
          const value = String(node.textContent || '').replace(/\s+/g, ' ').trim();
          return value && value.length <= 90 && titlePattern.test(value);
        }).sort((a, b) => {
          const aLength = String(a.textContent || '').trim().length;
          const bLength = String(b.textContent || '').trim().length;
          return aLength - bLength;
        });

        const title = titleCandidates[0];
        if (title) {
          title.style.setProperty('padding-inline-end', '58px', 'important');
          title.style.setProperty('padding-inline-start', '8px', 'important');
          title.style.setProperty('box-sizing', 'border-box', 'important');
          title.style.setProperty('max-width', '100%', 'important');
        }
      }

      shadow.querySelectorAll('*').forEach((node) => {
        if (node.shadowRoot) polishHost(node);
      });
    };

    candidates.forEach(polishHost);
  };

  const run = (root = document) => {
    polishNavigation(root);
    localizeInternalLinks(root);
    localizeJudgeMe(root);
    polishShopifyForms(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run(document), { once: true });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', (event) => run(event.target || document));

  let refreshTimer = null;
  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(() => run(document), 60);
  };

  const observer = new MutationObserver((mutations) => {
    let shouldRefresh = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          run(node);
          shouldRefresh = true;
        }
      });
    });
    if (shouldRefresh) scheduleRefresh();
  });

  const startObserver = () => {
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver, { once: true });

  // Judge.me is loaded asynchronously. These passes catch late widget rendering
  // and text updates that don't add a new outer widget element.
  [150, 400, 900, 1800, 3500, 6000].forEach((delay) => {
    window.setTimeout(() => run(document), delay);
  });

  /* CNobre Luxury — overlay coordinator 30-09-2026
   * Priority: Cookies > Shopify Forms 10% > Free Shipping.
   * Promotional overlays are held BEFORE they become visible, preventing
   * backdrop/focus flashes while the privacy dialog is still open.
   */
  const overlayCoordinator = (() => {
    const FORM_TITLE_RE = /10\s*%.*(?:primeira\s+encomenda|first\s+order|primer\s+pedido)/i;
    const COOKIE_TITLE_RE = /(?:consentimento\s+de\s+cookies|cookie\s+consent|consentimiento\s+de\s+cookies)/i;
    const PAUSED_ATTR = 'data-cnobre-overlay-paused';
    const FORM_HELD_ATTR = 'data-cnobre-form-held';

    const isVisible = (node) => {
      if (!(node instanceof Element)) return false;
      const style = window.getComputedStyle(node);
      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        Number.parseFloat(style.opacity || '1') === 0
      ) return false;

      const rect = node.getBoundingClientRect();
      return rect.width > 1 && rect.height > 1;
    };

    const allRoots = () => {
      const roots = [document];
      const queue = [document];

      while (queue.length) {
        const root = queue.shift();
        root.querySelectorAll?.('*').forEach((node) => {
          if (node.shadowRoot && !roots.includes(node.shadowRoot)) {
            roots.push(node.shadowRoot);
            queue.push(node.shadowRoot);
          }
        });
      }

      return roots;
    };

    const visibleTextMatch = (root, pattern) => {
      const nodes = root.querySelectorAll?.(
        'h1,h2,h3,[role="heading"],[role="dialog"],dialog,p,div,section,aside,form'
      ) || [];

      for (const node of nodes) {
        const value = String(node.textContent || '').replace(/\s+/g, ' ').trim();
        if (!value || value.length > 2600 || !pattern.test(value)) continue;
        if (isVisible(node)) return true;
      }

      return false;
    };

    const privacyApiPending = () => {
      try {
        const privacy = window.Shopify?.customerPrivacy;
        if (!privacy) return false;
        return typeof privacy.shouldShowBanner === 'function'
          ? privacy.shouldShowBanner() === true
          : false;
      } catch (_) {
        return false;
      }
    };

    const cookieDomOpen = () => {
      const exactSelectors = [
        '#shopify-pc__banner',
        '#shopify-pc__prefs',
        '[id^="shopify-pc__banner"]',
        '[id^="shopify-pc__prefs"]'
      ];

      for (const root of allRoots()) {
        for (const selector of exactSelectors) {
          const nodes = root.querySelectorAll?.(selector) || [];
          for (const node of nodes) {
            if (isVisible(node)) return true;
          }
        }

        if (visibleTextMatch(root, COOKIE_TITLE_RE)) return true;
      }

      return false;
    };

    const privacyOpen = () => privacyApiPending() || cookieDomOpen();

    const allFormsHosts = () => {
      const result = new Set();

      for (const root of allRoots()) {
        root.querySelectorAll?.(
          'shopify-forms-embed, [id^="app-embed-container-"], [id*="shopify-forms"], [class*="shopify-forms"]'
        ).forEach((host) => {
          if (!(host instanceof Element)) return;

          if (host.tagName === 'SHOPIFY-FORMS-EMBED') {
            result.add(host);
            return;
          }

          const shadow = host.shadowRoot;
          if (shadow && FORM_TITLE_RE.test(String(shadow.textContent || ''))) {
            result.add(host);
          }
        });
      }

      return Array.from(result);
    };

    const formIsOpen = (host) => {
      if (!(host instanceof Element)) return false;
      const shadow = host.shadowRoot;
      if (!shadow) return false;

      if (visibleTextMatch(shadow, FORM_TITLE_RE)) return true;

      const dialogs = shadow.querySelectorAll?.('[role="dialog"],dialog,form') || [];
      for (const dialog of dialogs) {
        const value = String(dialog.textContent || '').replace(/\s+/g, ' ').trim();
        if (FORM_TITLE_RE.test(value) && isVisible(dialog)) return true;
      }

      return false;
    };

    const pauseNode = (node, paused) => {
      if (!(node instanceof Element)) return;

      if (paused) {
        if (!node.hasAttribute(PAUSED_ATTR)) {
          node.setAttribute(PAUSED_ATTR, '1');
          node.style.setProperty('visibility', 'hidden', 'important');
          node.style.setProperty('opacity', '0', 'important');
          node.style.setProperty('pointer-events', 'none', 'important');
          node.style.setProperty('transition', 'none', 'important');
          node.style.setProperty('animation', 'none', 'important');
        }
        return;
      }

      if (!node.hasAttribute(PAUSED_ATTR)) return;

      node.removeAttribute(PAUSED_ATTR);
      node.style.removeProperty('visibility');
      node.style.removeProperty('opacity');
      node.style.removeProperty('pointer-events');
      node.style.removeProperty('transition');
      node.style.removeProperty('animation');
    };

    const shippingHost = () => document.querySelector('promo-popup');

    const shippingIsOpen = (host) => {
      if (!(host instanceof Element)) return false;
      const modal = host.querySelector('.sign-up-popup-modal');
      const overlay = host.querySelector('.sign-up-popup-overlay');

      return Boolean(
        modal?.classList.contains('popup-modal--active') ||
        overlay?.classList.contains('popup-overlay--active')
      );
    };

    const sync = () => {
      const forms = allFormsHosts();
      const shipping = shippingHost();
      const cookies = privacyOpen();

      if (cookies) {
        /*
         * PREVENTIVE HOLD: pause every Forms host and the shipping popup
         * before their own timers can paint a backdrop underneath cookies.
         */
        forms.forEach((host) => {
          host.setAttribute(FORM_HELD_ATTR, '1');
          pauseNode(host, true);
        });
        pauseNode(shipping, true);

        document.documentElement.setAttribute('data-cnobre-overlay-priority', 'cookies');
        return;
      }

      /*
       * Cookies are gone. Restore Shopify Forms first. If its 10 s timer
       * already elapsed while cookies were open, the form appears now.
       */
      forms.forEach((host) => pauseNode(host, false));

      const formsOpen = forms.some((host) => formIsOpen(host));

      if (formsOpen) {
        forms.forEach((host) => {
          if (formIsOpen(host)) host.setAttribute(FORM_HELD_ATTR, '1');
        });

        pauseNode(shipping, true);
        document.documentElement.setAttribute('data-cnobre-overlay-priority', 'forms');
        return;
      }

      forms.forEach((host) => host.removeAttribute(FORM_HELD_ATTR));

      /*
       * Nothing higher-priority is open. The 60 s shipping popup is free
       * to show if its own Shrine timer has elapsed.
       */
      pauseNode(shipping, false);

      if (shippingIsOpen(shipping)) {
        document.documentElement.setAttribute('data-cnobre-overlay-priority', 'shipping');
      } else {
        document.documentElement.removeAttribute('data-cnobre-overlay-priority');
      }
    };

    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;

      /*
       * MutationObserver + microtask runs before the next paint in normal
       * browser rendering, removing the 35 ms flash from the previous version.
       */
      queueMicrotask(() => {
        scheduled = false;
        sync();
      });
    };

    const observer = new MutationObserver(schedule);

    const start = () => {
      if (!document.body) return;

      /*
       * Run once BEFORE observation so existing promotional hosts are held
       * immediately when the privacy banner is already required.
       */
      sync();

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'open', 'aria-hidden']
      });

      document.addEventListener('visitorConsentCollected', schedule);
      document.addEventListener('shopify:section:load', schedule);

      [0, 50, 150, 400, 900, 1800].forEach((delay) => {
        window.setTimeout(schedule, delay);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.setInterval(sync, 250);

    return { sync, schedule };
  })();

})();